import store from "../store";
import { APIService } from "./api";
const apiService = new APIService();

export class APIServiceProperty {
  createProperty(data) {
    var config = {
      url: "/property",
      method: "post",
      headers: {
        "x-access-token": store.getters.token,
        "content-type": "application/json"
      },
      data: data
    };
    return apiService.api(config);
  }

  editProperty(data) {
    var config = {
      url: "/property/" + data.id,
      method: "put",
      headers: {
        "x-access-token": store.getters.token,
        "content-type": "application/json"
      },
      data: data
    };
    return apiService.api(config);
  }

  getProperty(propertyID) {
    var config = {
      url: "/property/" + propertyID,
      method: "get",
      headers: {
        "x-access-token": store.getters.token,
        "content-type": "application/json"
      }
    };
    return apiService.api(config);
  }

  getProperties() {
    var config = {
      url: "/property",
      method: "get",
      headers: {
        "x-access-token": store.getters.token,
        "content-type": "application/json"
      }
    };
    return apiService.api(config);
  }

  deleteProperty(propertyID) {
    var config = {
      url: "/property/" + propertyID,
      method: "delete",
      headers: {
        "x-access-token": store.getters.token,
        "content-type": "application/json"
      }
    };
    return apiService.api(config);
  }
}
